import React from 'react';
import { Construct } from '@carbon/pictograms-react';
import { EmptyState } from 'components/EmptyState';

const EmptyStatePage = () => {
  return (
    <EmptyState>
      <div className="add-member-no-data--wrapper">
        <Construct />
        <div className="add-member-empty-state-heading">
          There is no data to display
        </div>
      </div>
    </EmptyState>
  );
};

EmptyStatePage.displayName = 'EmptyStatePage';
export default EmptyStatePage;
